import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal } from 'react-bootstrap-5';

export default class CallListDeletionModal extends React.Component {
  static propTypes = {
    callList: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    shown: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = { newCallListName: null };

  handleDelete = () => {
    axios.delete(
      `/contacts/call_lists/${this.props.callList.id}`
    ).then(() => {
      this.props.onClose(true);
    }).catch(() => {
      this.props.onClose(false);
    });
  }

  render() {
    return (
      <Modal centered show={this.props.shown} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Call List</Modal.Title>
        </Modal.Header>
        <Modal.Body className="ms-2">
          <div className="mb-2">You are about to delete the following Call List:</div>
          <div><strong>{this.props.callList && this.props.callList.name}</strong></div>
          <div className="mt-2">This action is permanent. Are you sure you want to delete?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-ghost' onClick={this.props.onClose}>Cancel</button>
          <button className='btn btn-destructive' onClick={this.handleDelete}>Delete Call List</button>
        </Modal.Footer>
      </Modal>
    );
  }
}
